import React from "react";
import { Form, Field } from "react-final-form";
import Modal from "components/new/Modal";
import ModalBody from "components/new/ModalBody";
import ModalFooter from "components/new/ModalFooter";
import ModalHeader from "components/new/ModalHeader";
import Grid from "components/Grid";
import GridCell from "components/GridCell";
import RadioGroupPack from "components/RadioGroupPack";
import Alert from "components/Alert";
import { compose, withAppContext, withState } from "containers/HOC";
import SelectPack from "components/SelectPack2";
import * as validations from "common/validations";
import moment from "moment";

class ShareBudgetModal extends React.Component {
    _save = (values) => {
        this.props.modal.onConfirm(values);
    };

    _validate = (formValues) => {
        const errors = {};

        if (formValues.visibility === "Students") {
            errors.studentGroup = validations.required(formValues.studentGroup);
        }

        return errors;
    };

    render() {
        const { students = [], invitations = [], authContext = {}, viewModel = {} } = this.props;

        const shareOptions = [
            { value: "Farm", text: "All users with farm access" },
            { value: "Owner", text: "With the farm owner only" },
        ];

        const fullyShared = viewModel.visibility === "Farm";

        if (authContext.accountType === "EducationProvider") {
            if (fullyShared) {
                shareOptions.forEach((vm) => (vm.disabled = true));
            }
            shareOptions.push({ value: "Students", text: "Copy this analysis to student group" });
        }

        const invitationGroups = invitations.filter((s) => moment(s.expires).isAfter(moment().valueOf())).map((g) => g.group);
        const studentGroups = students.filter((s) => moment(s.expires).isAfter(moment().valueOf())).map((g) => g.group);
        const allGroups = [...new Set([...invitationGroups, ...studentGroups])]
            .filter((g) => g !== undefined)
            .sort((a, b) => (a < b ? -1 : 1))
            .map((g) => ({ value: g, text: g }));

        const { online } = this.props;
        return (
            <Form validate={this._validate} onSubmit={this._save}>
                {({ handleSubmit, submitSucceeded, values }) => {
                    return (
                        <Modal title="Share analysis" skinny={true}>
                            {({ closeModal }) => (
                                <form onSubmit={handleSubmit}>
                                    <ModalHeader>
                                        <Alert type="warning" text={`${fullyShared ? "This analysis is currently shared with all users with farm access so your only option is to share with students" : "Please ensure you select the correct user or group. Share actions cannot be undone."}`} />
                                    </ModalHeader>
                                    <ModalBody>
                                        <Grid>
                                            <GridCell>
                                                <div className="h3">Who do you wish to share the analysis with?</div>
                                                <Field name="visibility" options={shareOptions} inline={false} component={RadioGroupPack} />
                                                {values.visibility === "Students" && <Field name="studentGroup" label="Student group" placeholder="Select a group" options={allGroups} component={SelectPack} />}
                                            </GridCell>
                                        </Grid>
                                    </ModalBody>
                                    <ModalFooter>
                                        <div className="ButtonBar">
                                            <div className="ButtonBar-left">
                                                <button id="cancel-button" type="button" className="Button Button--secondary" onClick={closeModal}>
                                                    Cancel
                                                </button>
                                            </div>
                                            <div className="ButtonBar-right">
                                                <button id="save-button" type="submit" className="Button Button--primary" disabled={!online || !values.visibility || submitSucceeded}>
                                                    Share
                                                </button>
                                            </div>
                                        </div>
                                    </ModalFooter>
                                </form>
                            )}
                        </Modal>
                    );
                }}
            </Form>
        );
    }
}

export default compose(
    withAppContext,
    withState((state, ownProps) => {
        return {
            students: state.userManagement.students || [],
            invitations: state.userManagement.studentInvitations ? state.userManagement.studentInvitations.filter((i) => i.status !== "Accepted") : [],
        };
    })
)(ShareBudgetModal);
